var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-alert',{staticClass:"alert-danger",attrs:{"show":_vm.show,"variant":"danger","dismissible":""},on:{"dismissed":function($event){_vm.errosTemp=[]}}},[_c('h5',[_vm._v("Erro(s):")]),_vm._v(" "),_c('ul',_vm._l((_vm.errosTemp),function(erro){return _c('li',{key:erro},[_vm._v(_vm._s(erro))])}),0)])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ea13b908","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ErrosBoxComponent.vue
// module id = 687
// module chunks = 30